module.exports = __webpack_public_path__ + "static/media/Graphql_Grid.a84aebbe.png";